/* TG rotating search placeholder. Reads #tg-search-prompts-data.
   API: window.TGSearchPrompts = { init(rootEl), data, sequence } */
(function () {
  'use strict';

  var DATA_ID = 'tg-search-prompts-data';
  var INIT_ATTR = 'data-tg-rotator-init';
  var FADE_MS = 220;

  var api = window.TGSearchPrompts || {};
  if (api.__ready) { return; }

  function readData() {
    var out = { trending: [], prompts: [], intervalMs: 3000, salonUrl: '', searchUrl: '' };
    var el = document.getElementById(DATA_ID);
    if (!el) { return out; }
    try {
      var parsed = JSON.parse(el.textContent || '{}');
      out.trending = Array.isArray(parsed.trending) ? parsed.trending : [];
      out.prompts = Array.isArray(parsed.prompts) ? parsed.prompts : [];
      out.intervalMs = Math.max(1000, Number(parsed.intervalMs) || 3000);
      out.salonUrl = parsed.salonUrl || '';
      out.searchUrl = parsed.searchUrl || '';
    } catch (e) { /* keep defaults */ }
    return out;
  }

  function buildSequence(data) {
    var seq = [];
    var fi = 0;
    data.trending.forEach(function (term, i) {
      seq.push('Search ' + term + '…');
      if (i % 2 === 1 && data.prompts.length) {
        seq.push(data.prompts[fi % data.prompts.length]);
        fi += 1;
      }
    });
    if (!data.trending.length) { seq = data.prompts.slice(); }
    return seq;
  }

  function refresh() {
    api.data = readData();
    api.sequence = buildSequence(api.data);
  }

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(mq && mq.matches); }

  function attach(input) {
    var seq = api.sequence;
    var host = input.parentElement;
    if (!host || seq.length === 0) { return; }

    input.setAttribute(INIT_ATTR, 'true');
    host.classList.add('tg-search-rotator-host');

    var rot = document.createElement('span');
    rot.className = 'tg-search-rotator';
    rot.setAttribute('aria-hidden', 'true');
    rot.textContent = seq[0];
    input.insertAdjacentElement('afterend', rot);

    var index = 0;
    var focused = false;
    var timer = null;
    var swapTimer = null;

    function syncVisibility() {
      rot.classList.toggle('is-hidden', input.value !== '');
    }

    function show(text) {
      rot.textContent = text;
    }

    function advance() {
      if (focused || document.hidden || input.value !== '' || reduced() || seq.length < 2) { return; }
      index = (index + 1) % seq.length;
      rot.classList.add('is-leaving');
      clearTimeout(swapTimer);
      swapTimer = setTimeout(function () {
        show(seq[index]);
        rot.classList.remove('is-leaving');
        rot.classList.add('is-entering');
        void rot.offsetWidth;
        rot.classList.remove('is-entering');
      }, FADE_MS);
    }

    function start() {
      stop();
      if (reduced() || seq.length < 2) { return; }
      timer = setInterval(advance, api.data.intervalMs);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function applyMotionPref() {
      if (reduced()) {
        stop();
        clearTimeout(swapTimer);
        rot.classList.remove('is-leaving', 'is-entering');
        index = 0;
        show(seq[0]);
      } else {
        start();
      }
    }

    input.addEventListener('focus', function () { focused = true; });
    input.addEventListener('blur', function () { focused = false; syncVisibility(); });
    input.addEventListener('input', syncVisibility);
    if (input.form) {
      input.form.addEventListener('reset', function () { setTimeout(syncVisibility, 0); });
    }
    if (mq) {
      if (mq.addEventListener) { mq.addEventListener('change', applyMotionPref); }
      else if (mq.addListener) { mq.addListener(applyMotionPref); }
    }

    syncVisibility();
    applyMotionPref();
  }

  function init(rootEl) {
    var root = rootEl || document;
    if (!api.sequence || !api.sequence.length) { refresh(); }
    if (!api.sequence.length) { return; }
    var inputs = root.querySelectorAll('input[data-tg-rotating-placeholder]:not([' + INIT_ATTR + '])');
    Array.prototype.forEach.call(inputs, attach);
  }

  api.init = init;
  api.__ready = true;
  window.TGSearchPrompts = api;
  refresh();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();
